import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subject, Subscription } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { StandardDesignParameters, StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "src/app/app.component";
import { CustomValidators } from "src/app/validators/custom.validators";
import { Lang } from "src/app/model/lang";
import { DEFAULT_LANG } from "src/app/conf/languages";
import { selectCurrentLang, selectUser } from "src/app/store/user/user.selector";
import { User } from "src/app/model/user";

@Component({
	selector: 'app-password-update',
	templateUrl: './password-update.component.html',
	styles: `
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}

		.noSelectLabel-pswUpd {
			user-select: none;
			-webkit-user-select: none;
		}
	`
})

export class PasswordUpdateComponent implements OnInit, OnDestroy {
	updatePasswordForm: FormGroup;
	decodedData: {
		Email: string;
		Verification: string;
		Time: number;
	};
	destroyed$ = new Subject<boolean>();


	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;

	// design
	screenWidth: number;
	screenHeight: any;
	MAX_MD_WIDTH = 1120;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private store: Store<AppState>,
		public app: AppComponent,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();

		const data = this.route.snapshot.queryParams["data"];
		if (!data) {
			// this.messages.warning('NOT_AUTHORIZED');
			this.router.navigate(['/login']);
		}
		this.decodedData = JSON.parse(atob(data));

		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	initSelectors() {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.currentUser$ = this.store.select(selectUser);
	}

	subscribeAll() {
		this.currentLang$.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
	}

	ngOnDestroy(): void {
		this.currentUserSub?.unsubscribe();
	}

	buildForm(): void {
		this.updatePasswordForm = new FormGroup({
			'password': new FormControl('', [Validators.required, Validators.pattern('^(?!.* )(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$')]),
			'passwordConfirm': new FormControl('', [Validators.required, Validators.pattern('^(?!.* )(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$')])
		});
		this.updatePasswordForm.setValidators(CustomValidators.checkMatchingFields('password', 'passwordConfirm'));
	}

	getMenuTheme(): string {
		return this.app.menuTheme;
	}

	get f(): any {
		return this.updatePasswordForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.updatePasswordForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.updatePasswordForm.get(key).errors;
			if (controlErrors != null) {
				/*Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				});*/
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const reqData = {
			email: this.decodedData.Email,
			pwd: this.f.password.value,
			verification: this.decodedData.Verification,
			time: this.decodedData.Time,
			lang: this.currentLang,
			countryName: undefined,//NOT PRESENT IN THIS MOMENT
		};
		this.store.dispatch(AuthActions.updatePassword(reqData));
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
		this.screenHeight = window.innerHeight;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	justifyMessagesNewValidator(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrorsCustomColor(type: PasswordUpdateComponent["f"], classType: string, borderColor: string): string {
		return StandardNewValidator.newShowErrorsCustomColor(type, classType, this.screenWidth, borderColor);
	}

	showErrorsConfirmFieldsCustomColor(type: PasswordUpdateComponent["f"], classType: string, notEquivalentType: string, borderColor: string): string {
		return StandardNewValidator.showErrorsConfirmFieldsCustomColor(type, classType, notEquivalentType, this.screenWidth, this.updatePasswordForm, borderColor);
	}

	showErrorConfirmInvalidMessage(type: PasswordUpdateComponent["f"], notEquivalentType: string): boolean {
		return StandardNewValidator.showErrorConfirmInvalidMessage(type, notEquivalentType, this.updatePasswordForm);
	}

	showErrorRequiredMessage(type: PasswordUpdateComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	fixedFooter(): string {
		return (this.screenHeight >= StandardDesignParameters.LG_HEIGHT) && (this.screenWidth >= StandardDesignParameters.FOOTER_EXTENDED_MIN_WIDTH) ? "fixed bottom-0 min-w-screen" : "";
	}

	minHeightScreen(): string {
		return (this.screenWidth <= StandardDesignParameters.FOOTER_EXTENDED_MIN_WIDTH) ? "" : "min-h-screen"
	}

	onLargeDesktop(): string {
		return (this.screenHeight >= StandardDesignParameters.LARGE_DESKTOP) && (this.screenWidth >= StandardDesignParameters.FOOTER_EXTENDED_MIN_WIDTH) ? "col-12 flex" : "";
	}
}
